import styled from "styled-components"

export const List = styled.div`
  border-top: 1px solid var(--line-strong);
`

export const Row = styled.article`
  display: grid;
  gap: 1.25rem 3rem;
  padding: 2.5rem 0;
  border-bottom: 1px solid var(--line);
  @media (min-width: 992px) {
    grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
    padding: 3.5rem 0;
  }
`

export const Aside = styled.div`
  h3 {
    margin-bottom: 0.5rem;
    max-width: 16ch;
  }
`

export const StackLine = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: var(--muted);
`

export const Body = styled.div`
  max-width: var(--measure);
`

export const Lead = styled.p`
  font-size: 1.125rem;
  line-height: 1.55;
`

export const For = styled.p`
  color: var(--muted);
  strong {
    color: var(--text);
  }
`

export const Benefits = styled.ul`
  list-style: none;
  margin: 0 0 0.5rem;
  padding: 0;
  li {
    position: relative;
    padding-left: 1.5rem;
    margin-bottom: 0.5rem;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0.8em;
      width: 0.8rem;
      height: 2px;
      background: var(--navy);
    }
  }
`

export const Details = styled.div`
  display: grid;
  gap: 1.25rem 2rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--line);
  @media (min-width: 576px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  p {
    margin: 0;
    font-size: 0.95rem;
    color: var(--muted);
  }
`
